<template>
    <div>
      <div class="wrapper wrapper-content  animated fadeInRight">
        <div class="row m-b-lg m-t-lg">
          <div class="col-md-6">
            <div>
              <div class="">
                <div>
                  <h2 class="no-margins">
                    <router-link :to="'/site/' + site.id">{{ site.name }}</router-link>
                  </h2>
                  <h4>
                    <router-link tag="a" :to="'/site/' + site.id">
                      {{ site.url }}
                    </router-link>
                  </h4>
                  <small>
                    <span class="label label-primary" v-for="tag in site.tags" :key="tag">{{ tag }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <table class="table small m-b-xs" v-if="siteLoaded">
              <tbody>
              <tr>
                <td>Category</td>
                <td><b>{{ site.stats.ttf0 }}</b></td>
              </tr>
              <tr>
                <td>RD</td>
                <td><b>{{ site.stats.rd }}</b></td>
              </tr>
              <tr>
                <td>TF</td>
                <td><b>{{ site.stats.tf }}</b></td>
              </tr>
              <tr>
                <td>DA</td>
                <td><b>{{ site.stats.da }}</b></td>
              </tr>
              <tr>
                <td>Traffic</td>
                <td><b>{{ site.stats.traffic }}</b></td>
              </tr>
              <!--<tr v-for="prop in siteProps" :key="prop.desc">-->
                <!--<td>-->
                  <!--{{ prop.desc }}-->
                <!--</td>-->
                <!--<td>-->
                  <!--<strong>{{ prop.value }}</strong>-->
                <!--</td>-->
              <!--</tr>-->
              </tbody>
            </table>
          </div>
          <div class="col-md-3">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <component :is="activeComponent" :site="site" @switchComponent="activeComponent = $event" :posts="posts"></component>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import axios from 'axios'
import Post from './Post.vue'
import PostList from './PostList.vue'
import { eventBus } from '../../../main'

export default {
  name: 'Site',
  data () {
    return {
      site: {},
      siteLoaded: false,
      posts: [],
      postsLoaded: false,
      activeComponent: PostList,
      siteProps: []
    }
  },
  components: {
    postList: PostList,
    post: Post
  },
  mounted () {
    this.getSite(this.$route.params.id)
    if ('postId' in this.$route.params) {
      this.activeComponent = Post
    }
  },
  watch: {
    $route (to, from) {
      if ('postId' in to.params) {
        this.activeComponent = Post
      } else {
        this.activeComponent = PostList
        this.getPosts(this.$route.params.id)
      }
    }
  },
  methods: {
    getSite (id) {
      axios.get(process.env.API + '/site/' + id)
        .then(response => {
          this.site = response.data
          let showProps = [
            'blog_url', 'blog_title', 'blog_tagline'
          ]

          showProps.forEach((index) => {
            if (showProps.includes(index)) {
              this.siteProps.push(this.site.data[index])
            }
          })

          this.siteLoaded = true
          this.posts = this.getPosts(id)
        })
        .catch(e => {
          this.$swal({
            type: 'error',
            title: 'Access denied',
            text: 'You do not have access to this site.'
          })
        })
    },
    getPosts (id) {
      axios.get(process.env.API + '/site/' + id + '/posts')
        .then(response => {
          eventBus.$emit('postList', response.data.data)
          this.postsLoaded = true
        })
        .catch()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Site/Site.vue